// extracted by mini-css-extract-plugin
module.exports = {"item":"W2Penalties_item__mT_sP","item__title":"W2Penalties_item__title__ZZOdm"};